<div class="flex-wrap flex-wrap--flex-start">
  <div class="flex-wrap__col flex-wrap__col--50">
    <h3>Beskrivelse</h3>
    <p>{{ incidentDetails.description }}</p>
  </div>
  <div class="flex-wrap__col flex-wrap__col--50">
    <h3>Yderligere information</h3>
    <table class="table">
      <tbody>
        <tr valign="top">
          <td>
            <strong>Ladestander ID:</strong>
          </td>
          <td class="align-right">
            {{ incidentDetails.chargingStationIdentifier }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="margin--top-xl">
  <h3>Hændelseslog</h3>
  <table class="table">
    <thead>
      <tr>
        <th class="align-left">Status</th>
        <th class="align-left">Tidspunkt</th>
        <th class="align-left">Ændring</th>
        <th class="align-left">Udført af</th>
      </tr>
    </thead>
    <tbody>
      @for (event of incidentDetails.incidentEvents; track event) {
        <tr>
          <td>{{ event.status | translateIncidentStatusEnum }}</td>
          <td class="no-wrap">{{ event.created | date: 'short' }}</td>
          <td>
            {{ event.comment | slice: 0 : 250 }}
            @if (event.comment.length >= 250) {
              ...
              <button class="btn-icon inline blue underline" (click)="openOverflowText(event.comment)">Vis komplet tekst</button>
            }
          </td>
          <td>{{ event.createdBy }}</td>
        </tr>
      }
    </tbody>
  </table>
</div>
